export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "liquidation": {
            "month": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mes"])},
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semana"])},
            "registered_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha"])},
            "liquidation_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "number_boxes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cajas"])},
            "number_kg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kg"])},
            "amount_per_kg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retorno USD por Kg"])},
            "amount_per_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio Caja"])},
            "total_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
            "crop_variety_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Variedad"])},
            "crop_size_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calibre"])},
            "crop_category_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categoría"])}
          }
        }
      },
      "en": {
        "model": {
          "liquidation": {
            "month": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" Month"])},
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Week"])},
            "registered_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date"])},
            "liquidation_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code"])},
            "number_boxes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boxes"])},
            "number_kg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kg"])},
            "amount_per_kg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["USD per Kg"])},
            "amount_per_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amount per Package"])},
            "total_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
            "crop_variety_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Variety"])},
            "crop_size_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Size"])},
            "crop_category_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Category"])}
          }
        }
      }
    }
  })
}